import { render } from "./SubjectDetail.vue?vue&type=template&id=610422f9&scoped=true"
import script from "./SubjectDetail.vue?vue&type=script&lang=js"
export * from "./SubjectDetail.vue?vue&type=script&lang=js"

import "./SubjectDetail.vue?vue&type=style&index=0&id=610422f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610422f9"]])

export default __exports__